export const T = {
  en_GB: {
    // The locale this table is for — the member lines format "{rep} ({role})" with it.
    locale: "en_GB",
    quizLabel: "Knowledge quiz",
    questionnaireLabel: "Questionnaire",
    // QL-505 — per-member group rendering
    memberCountPassed: (passed: number, total: number) => `${passed} of ${total} passed`,
    expandMembers: "Show members",
    collapseMembers: "Hide members",
    // QL-654 — a client with 2+ representatives: every representative answers for themselves.
    expandRepresentatives: "Show representatives",
    collapseRepresentatives: "Hide representatives",
  },
  nb_NO: {
    locale: "nb_NO",
    quizLabel: "Kunnskapsquiz",
    questionnaireLabel: "Spørreskjema",
    memberCountPassed: (passed: number, total: number) => `${passed} av ${total} bestått`,
    expandMembers: "Vis medlemmer",
    collapseMembers: "Skjul medlemmer",
    expandRepresentatives: "Vis representanter",
    collapseRepresentatives: "Skjul representanter",
  },
} as const;
